// src/components/BGP/request/request.ts
import axios from "axios";

/** Determina la URL base de la API **/
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

/** ========== BGP ========== **/
export function getNeighborsStatus(token: string) {
    return axios.get(`${API_V1_URL}/ctxr/-1/statusneighbor?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/** ========== CloudHealth ========== **/
export function getCloudHealth(token: string) {
    return axios.get(`${API_V1_URL}/suscription/-1/CloudHealth?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/** ========== Instances ========== **/
export function getInstancesStatus(token: string) {
    return axios.get(`${API_V1_URL}/ctxr/-1/statusctxr?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/** ========== HA ==========
 *  GET /ClusterCtxr/-1/list?tenantId=1
**/
export function getHAStatus(token: string) {
    return axios.get(`${API_V1_URL}/ClusterCtxr/-1/list?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}
